import { useDisclosure } from '@chakra-ui/hooks';
import {
  Box,
  Button,
  Card,
  Container,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  Flex,
  Heading,
  SimpleGrid,
  Stack,
  Text,
} from '@chakra-ui/react';
import { FormProvider, useForm } from 'react-hook-form';
import { FiDownloadCloud } from 'react-icons/fi';
import { AppInput, FormButtonGroup, MultiBar, PageCard } from './components';

export interface DashboardPageProps {}

const ShadowBox = (props: {}) => {
  return (
    <PageCard m={18}>
      <Box p={32}>
        <b>Chart Placeholder</b>
      </Box>
    </PageCard>
  );
};
export const DashboardPage = (props: DashboardPageProps) => {
  const { isOpen, onToggle } = useDisclosure();
  const form = useForm({ mode: 'all', defaultValues: { name: '' } });

  // useEffect(() => {
  //   form.setError('name', { type: 'foo', message: 'YOU SUCK' });
  // }, [form]);

  return (
    <Stack spacing={{ base: '8', lg: '6' }}>
      <Stack
        spacing="4"
        direction={{ base: 'column', lg: 'row' }}
        justify="space-between"
      >
        <Stack spacing="1">
          <Heading size={{ base: 'xs', lg: 'sm' }} fontWeight="medium">
            Dashboard
          </Heading>
          <Text color="muted">All important metrics at a glance</Text>
        </Stack>
      </Stack>
      <SimpleGrid columns={4}>
        <ShadowBox />
        <ShadowBox />
        <ShadowBox />
        <ShadowBox />
        <ShadowBox />
        <ShadowBox />
        <ShadowBox />
        <ShadowBox />
        <ShadowBox />
        <ShadowBox />
        <ShadowBox />
        <ShadowBox />
      </SimpleGrid>
    </Stack>
  );
};
